// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1CYcn","container":"styles_container__1_F4E","title":"styles_title__2Ubjg","wrapper":"styles_wrapper__3pc_z","answer":"styles_answer__s240g"};